import { useState } from 'react';
import { AskAiButton } from './askAiButton';
import { AiChatWindow } from './aiChatWindow';

interface AiAssistantFabProps {
  /** Bottom offset (px) for the launcher button. Default 100, so it stacks above the "Chat with us" FAB (bottom:30) wherever that also appears. */
  bottom?: number;
  /** Right offset (px) for the launcher button. Default 30. */
  right?: number;
  /** Iframe source. Defaults to the platform chat-bot embed route. */
  src?: string;
  label?: string;
}

/**
 * The single, global "Ask AI" launcher: shows the pill button, and opens the
 * chat-bot iframe panel on click. Mount once per app (e.g. in app.tsx) so its
 * position stays uniform across every screen.
 */
export const AiAssistantFab = ({ bottom = 100, right = 30, src, label }: AiAssistantFabProps) => {
  const [open, setOpen] = useState(false);

  if (open) {
    return (
      <AiChatWindow
        onClose={() => setOpen(false)}
        src={src}
        buttonBottom={bottom}
        buttonRight={right}
      />
    );
  }

  return <AskAiButton onClick={() => setOpen(true)} bottom={bottom} right={right} label={label} />;
};

export default AiAssistantFab;
